import clsx from 'clsx';
import { HTMLAttributes } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

import { FieldWrapper, FieldWrapperPassThroughProps } from './FieldWrapper';

type InputFieldProps = FieldWrapperPassThroughProps & {
  type?: 'text' | 'email' | 'password';
  className?: string;
  inputMode?: HTMLAttributes<HTMLInputElement>['inputMode'];
  registration: Partial<UseFormRegisterReturn>;
};

export const InputField = (props: InputFieldProps) => {
  const {
    type = 'text',
    inputMode,
    label,
    placeholder,
    className,
    registration,
    error,
  } = props;
  return (
    <FieldWrapper label={label} error={error}>
      <input
        type={type}
        placeholder={placeholder}
        autoComplete="off"
        inputMode={inputMode}
        className={clsx(
          'appearance-none block h-[50px] px-[20px] md:px-[33px] py-2 rounded shadow-sm drop-shadow placeholder-[#CCCED1] focus:outline-none focus:ring-primary sm:text-sm',
          [error?.message ? 'border border-1 border-red' : 'border-none'],
          className
        )}
        {...registration}
      />
    </FieldWrapper>
  );
};
